import { registerComponent } from "helpers";
import WYATTElement from "wyatt";
import StoreAvailability from "store-availability";

registerComponent(
  "add-to-cart-validation",
  class AddToCartValidation extends WYATTElement {
    constructor() {
      super();

      this.StoreAvailability = new StoreAvailability(this);

      this.available = false;

      this.availableAction = this.querySelector("[data-action='available']");
      this.unavailableAction = this.querySelector(
        "[data-action='unavailable']",
      );

      this.validate();

      this.form = this.closest("form");

      /*
        This event listener is added to the form in the capture phase,
        which runs before the listener added by <product-form>. This is
        so that the availability check can block the add-to-cart when the
        product is unavailable. If the listener was added to the form in
        the bubble phase, the product could still be added to the cart when
        unavailable.
      */
      this.onPreferredStoreChange = this.handlePreferredStoreChange.bind(this);

      this.form.addEventListener("submit", this.handleSubmit.bind(this), true);
    }

    async handleSubmit(event) {
      /*
        If the product is available or the availability has not been checked yet,
        do not block the add-to-cart. (Error on the side of letting the user add to cart)
      */
      if (this.available || !this.dataset.availability) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    }

    connectedCallback() {
      this.dataset.storeNumber = this.StoreAvailability.storeNumber;

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.onPreferredStoreChange,
      );
    }

    handlePreferredStoreChange(store) {
      this.dataset.storeNumber = store?.store_number;

      this.validate();
    }

    async validate() {
      this.dataset.availability =
        await this.StoreAvailability.getAvailability();

      this.available = this.StoreAvailability.isAvailable;
    }
  },
);
